<template>
<ValidationObserver v-slot="{ invalid, handleSubmit, failed }" ref="observer">
    <form class="extra-form" @submit.prevent="handleSubmit(saveExtra)" novalidate>
        <div class="extra__wrapper edit-box box-shadow" :class="{ 'is-locked' : !isEditMode }">
            <div class="extra__wrapper--inner">
                <div class="columns">
                    <div class="column">
                        <div class="edit-box__header">
                            <div class="is-clearfix">
                                <div class="edit-box__headline-wrapper is-pulled-left">
                                    <h3 class="edit-box__headline" v-if="!isEditMode"> {{ extraCopy.name}}</h3>
                                    <h4 v-if="extraCopy.code && !isEditMode">
                                        Code: <strong>{{ extraCopy.code }}</strong>
                                        <template v-if="extraCopy.external_id">
                                            | {{ $t('extras.external_id') }}: <strong>{{ extraCopy.external_id }}</strong>
                                        </template>
                                    </h4>
                                    <ValidationProvider v-if="isEditMode" vid="Name" v-slot="{ errors }" rules="required">
                                        <input
                                        type="text"
                                        placeholder="name" class="edit-box--input input"
                                        @click="fromFieldClicked('name')"
                                        :class="{'is-danger': errors[0] }"
                                        name="extraCopy.name"
                                        v-model="extraCopy.name"
                                        >
                                        <span v-show="errors[0]" class="help is-danger">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                    <h4 v-if="extraCopy.code && isEditMode" class="extra-code-edit">Code: <strong>{{ extraCopy.code }}</strong></h4>
                                </div>
                                <div class="edit-box__toggle-edit is-pulled-right" @click="toggleEditMode()">
                                    <a class="button" v-show="!isEditMode"><i class="fa fa-pencil-square-o fa-lg" aria-hidden="true"></i></a>
                                    <a class="button" v-show="isEditMode"><i class="fa fa-times fa-lg" aria-hidden="true"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                 <div class="edit-box__section extra__wysiwyg" v-if="!isEditMode"  v-html="extraCopy.description"></div>
                <div class="edit-box__section extra__wysiwyg" v-if="isEditMode">
                    <wysiwyg v-model="extraCopy.description" v-if="isEditMode" :options="{maxChars: 300}" @click.native="fromFieldClicked('description')"></wysiwyg>
                </div>

                <div class="edit-box__section" v-if="!isEditMode && !mandatory">
                    <i>{{ extraTypes[extraCopy.extra_type] }}</i>
                </div>
                <div class="edit-box__section" v-if="isEditMode && !mandatory">
                    <div v-for="(value, key) in extraTypes" v-if="key !== 'mandatory'">
                        <ValidationProvider name="extra_type" v-slot="{ errors }" rules="required">
                            <label class="radio" :class="{'is-error': errors[0]}">
                                <input type="radio" name="extra_type" :value="key" v-model="extraCopy.extra_type" @click="fromFieldClicked('extra_type')" />
                                <span class="is-unselectable" :class="{'is-disabled': extraCopy.extra_type === key}">{{ value }}</span>
                            </label>
                        </ValidationProvider>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-6">
                        <div class="edit-box__section">
                            <label for="billing_type" class="label is-inline-block edit-box__includes-inline-input">
                                {{ $t('extras.billingType') }}:
                            </label>
                            <span v-if="!isEditMode" class="edit-box__includes-inline-input">{{ realBillingTypes[extraCopy.billing_type] }}</span>

                            <ValidationProvider name="billing_type" v-slot="{ errors }" rules="required">
                                <span v-if="isEditMode" class="select">
                                    <select id="billing_type" v-model="extraCopy.billing_type"
                                            :class="{'is-danger': errors[0] }"
                                            name="billing_type" @click="fromFieldClicked('billing_type')">
                                        <option v-for="(value, key) in realBillingTypes" :value="key">
                                        {{ value }}
                                        </option>
                                    </select>
                                </span>
                                <span v-show="errors[0] && isEditMode" class="help is-danger">{{ errors[0] }}</span>
                            </ValidationProvider>

                        </div>
                    </div>

                    <div class="column is-6">
                        <div class="edit-box__section">
                            <label for="extra_sub_type" class="label is-inline-block edit-box__includes-inline-input">
                                {{ $t('extras.extraSubType') }}:
                            </label>
                            <span v-if="!isEditMode" class="edit-box__includes-inline-input">{{ extraSubTypes[extraCopy.extra_sub_type] }}</span>
                            <ValidationProvider name="extra_sub_type" v-slot="{ errors }" rules="required">
                                <span v-if="isEditMode" class="select">
                                    <select id="extra_sub_type" v-model="extraCopy.extra_sub_type"
                                            :class="{'is-danger': errors[0] }"
                                            name="extra_sub_type" @click="fromFieldClicked('extra_sub_type')">
                                        <option v-for="(value, key) in extraSubTypes" :value="key">
                                        {{ value }}
                                        </option>
                                    </select>
                                </span>
                                <span v-show="errors[0] && isEditMode" class="help is-danger">{{ errors[0] }}</span>
                            </ValidationProvider>

                        </div>
                    </div>
                </div>

                <div class="columns" v-if="priceAllowed()">
                    <div class="column is-12">
                        <UseDayPrices :lang="lang" :only-day-prices="onlyDayPrices" :data-copy="extraCopy"/>
                        <div class="edit-box__section" v-if="isEditMode && !extraCopy.id">
                            <label for="price" class="label is-inline-block edit-box__includes-inline-input">
                                {{ $t('extras.price') }} als Standard für die Neuanlage:

                                <span class="tooltip-activator d-inline-flex">
                                  <i class="fa fa-info icon-border" aria-hidden="true" />
                                  <span class="tooltip tooltip--is-large">{{ $t('bookings.newBookingInfo') }}</span>
                                </span>
                            </label>
                            <span v-if="!isEditMode" class="edit-box__includes-inline-input">{{ extraCopy.price | currency($getDefaultCurrency().code, lang) }}</span>

                            <ValidationProvider name="price" v-slot="{ errors }" rules="required|min_value:0|max_value:999">
                                <input v-if="isEditMode"
                                    class="input edit-box__inline-input is-price"
                                    type="number" id="price"
                                    name="price" v-model="extraCopy.price"
                                    :class="{'is-danger': errors[0] || extraCopy.price == undefined }"
                                    min="0" max="999" @click="fromFieldClicked('price')">
                                <span v-show="errors[0] && isEditMode" class="help is-danger">{{ errors[0] }}</span>
                                <span class="edit-box__includes-inline-input" v-if="isEditMode">{{ $getDefaultCurrency().symbol }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                </div>

                <div class="columns" v-if="priceAllowed()">
                    <div class="column is-12">
                        <div class="edit-box__section">
                            <label for="transit_item" class="checkbox label">
                                {{ $t('extras.transitItem') }}:
                                <span class="icon is-small" v-if="!isEditMode">
                                    <i aria-hidden="true" class="fa fa-check-circle is-valid" v-if="extraCopy.transit_item"></i>
                                    <i aria-hidden="true" class="fa fa-minus-circle is-invalid" v-else></i>
                                </span>

                                <input v-if="isEditMode"
                                    class="edit-box__inline-input"
                                    type="checkbox"
                                    id="transit_item"
                                    name="transit_item"
                                    v-model="extraCopy.transit_item"
                                    @click="fromFieldClicked('transit_item')"
                                    >
                            </label>
                            <span>{{ $t('extras.transitItemHelp') }}</span>
                        </div>
                    </div>
                </div>

                <div class="edit-box__section" v-if="isEditMode">
                    <label for="external_id" class="label">
                        {{ $t('extras.external_id') }}:
                    </label>

                    <input v-if="isEditMode"
                           class="edit-box--input input is-inline-block"
                           type="text"
                           id="external_id"
                           name="extraCopy.external_id"
                           v-model="extraCopy.external_id"
                           @click="fromFieldClicked('transit_item')"
                    >

                    <span>{{ $t('extras.external_id_info') }}</span>
                </div>

                <div class="edit-box__section">
                    <label for="can_be_free" class="label">
                        {{ $t('extras.can_be_free') }}:
                        <span class="icon is-small" v-if="!isEditMode">
                            <i aria-hidden="true" class="fa fa-check-circle is-valid" v-if="extraCopy.can_be_free"></i>
                            <i aria-hidden="true" class="fa fa-minus-circle is-invalid" v-else></i>
                        </span>

                        <input v-if="isEditMode"
                            class="edit-box__inline-input"
                            type="checkbox"
                            id="can_be_free"
                            name="can_be_free"
                            v-model="extraCopy.can_be_free"
                            @click="fromFieldClicked('can_be_free')"
                            >
                    </label>
                    <span>{{ $t('extras.can_be_free_info') }}</span>
                </div>



                <div class="columns">
                    <div class="column is-12" v-if="!isEditMode && ((extraCopy.rule_duration_from && extraCopy.rule_duration_from >= 0) || (extraCopy.rule_duration_to && extraCopy.rule_duration_to >= 0))">
                        <div class="edit-box__section">
                            <label class="label is-inline-block edit-box__includes-inline-input">
                                {{ $t('extras.ruleDuration.label') }} {{ extraCopy.rule_duration_from}} {{ $t("extras.ruleDuration.to")}} {{ extraCopy.rule_duration_to}} {{ $t("extras.ruleDuration.postLabel")}}
                            </label>
                        </div>
                    </div>

                    <div class="column is-12" v-if="isEditMode">
                        {{ $t('extras.ruleDuration.label') }}
                        <input class="extra-day-input"
                               type="number"
                               v-model="extraCopy.rule_duration_from"
                        >
                        {{ $t("extras.ruleDuration.to")}}
                        <input class="extra-day-input"
                               type="number"
                               v-model="extraCopy.rule_duration_to"
                        >
                        {{ $t("extras.ruleDuration.postLabel")}}
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-12" v-if="!isEditMode && ((extraCopy.rule_persons_from && extraCopy.rule_persons_from >= 0) || (extraCopy.rule_persons_to && extraCopy.rule_persons_to >= 0))">
                        <div class="edit-box__section">
                            <label class="label is-inline-block edit-box__includes-inline-input">
                                {{ $t('extras.rulePersons.label') }} {{ extraCopy.rule_persons_from}} {{ $t("extras.rulePersons.to")}} {{ extraCopy.rule_persons_to}} {{ $t("extras.rulePersons.postLabel")}}
                            </label>
                        </div>
                    </div>

                    <div class="column is-12" v-if="isEditMode">
                        {{ $t('extras.rulePersons.label') }}
                        <input class="extra-day-input"
                               type="number"
                               v-model="extraCopy.rule_persons_from"
                        >
                        {{ $t("extras.rulePersons.to")}}
                        <input class="extra-day-input"
                               type="number"
                               v-model="extraCopy.rule_persons_to"
                        >
                        {{ $t("extras.rulePersons.postLabel")}}
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-12" v-if="!isEditMode && ((extraCopy.rule_pets_from && extraCopy.rule_pets_from >= 0) || (extraCopy.rule_pets_to && extraCopy.rule_pets_to >= 0))">
                        <div class="edit-box__section">
                            <label class="label is-inline-block edit-box__includes-inline-input">
                                {{ $t('extras.rulePets.label') }} {{ extraCopy.rule_pets_from}} {{ $t("extras.rulePets.to")}} {{ extraCopy.rule_pets_to}} {{ $t("extras.rulePets.postLabel")}}
                            </label>
                        </div>
                    </div>

                    <div class="column is-12" v-if="isEditMode">
                        {{ $t('extras.rulePets.label') }}
                        <input class="extra-day-input"
                               type="number"
                               v-model="extraCopy.rule_pets_from"
                        >
                        {{ $t("extras.rulePets.to")}}
                        <input class="extra-day-input"
                               type="number"
                               v-model="extraCopy.rule_pets_to"
                        >
                        {{ $t("extras.rulePets.postLabel")}}

                        <div style="margin-top: 10px;">
                            <label for="rule_pets_none" class="checkbox label">
                                {{ $t('extras.rulePets.checkbox') }}:
                                <span class="icon is-small" v-if="!isEditMode">
                                    <i aria-hidden="true" class="fa fa-check-circle is-valid" v-if="extraCopy.rule_pets_none"></i>
                                    <i aria-hidden="true" class="fa fa-minus-circle is-invalid" v-else></i>
                                </span>

                                <input v-if="isEditMode"
                                    class="edit-box__inline-input"
                                    type="checkbox"
                                    id="rule_pets_none"
                                    name="rule_pets_none"
                                    v-model="extraCopy.rule_pets_none"
                                    @click="fromFieldClicked('transit_item')"
                                    >
                            </label>
                        </div>
                        </div>


                </div>

                <div class="columns">
                    <div class="column is-12">
                        <div class="edit-box__section" v-if="billingTypeForPersons()">
                            <label for="extra_sub_type" class="label is-inline-block edit-box__includes-inline-input" v-if="isEditMode || extraCopy.only_for_person">
                                {{ $t('extras.onlyForPerson.label') }}:
                            </label>
                            <span v-if="!isEditMode" class="edit-box__includes-inline-input">{{ personTextById(extraCopy.only_for_person) }}</span>
                            <ValidationProvider name="only_for_person" v-slot="{ errors }">
                                <span v-if="isEditMode" class="select">
                                    <select id="only_for_person" v-model="extraCopy.only_for_person"
                                            :class="{'is-danger': errors[0] }"
                                            name="only_for_person" @click="fromFieldClicked('only_for_person')">
                                        <option value="">-</option>
                                        <option v-for="(value, key) in persons()" :value="key">
                                        {{ value }}
                                        </option>
                                    </select>
                                </span>
                                <span v-show="errors[0] && isEditMode" class="help is-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-4">
                        <div class="edit-box__section">
                            <label class="label is-inline-block edit-box__includes-inline-input">
                                {{ $t('extras.bookableFor.label') }}:
                            </label>
                        </div>
                    </div>
                    <div class="column is-8">
                        <div class="edit-box__section bookable_for is-clearfix" v-if="simpleCampsiteTypes">
                            <label class="checkbox">
                                <span class="icon is-small" v-if="!isEditMode">
                                    <i aria-hidden="true" class="fa fa-check-circle is-valid" v-if="extraCopy.applies_for_accommodation"></i>
                                    <i aria-hidden="true" class="fa fa-minus-circle is-invalid" v-else></i>
                                </span>
                                <input v-if="isEditMode"
                                    class="edit-box__inline-input"
                                    type="checkbox" id="applies_for_accommodation"
                                    name="applies_for_accommodation" v-model="extraCopy.applies_for_accommodation"
                                    @click="fromFieldClicked('applies_for_accommodation')">
                                {{ $t('extras.bookableFor.accommodation') }}
                            </label>

                            <label class="checkbox">
                                <span class="icon is-small" v-if="!isEditMode">
                                    <i aria-hidden="true" class="fa fa-check-circle is-valid" v-if="extraCopy.applies_for_camping"></i>
                                    <i aria-hidden="true" class="fa fa-minus-circle is-invalid" v-else></i>
                                </span>
                                <input v-if="isEditMode"
                                    class="edit-box__inline-input"
                                    type="checkbox" id="applies_for_camping"
                                    name="applies_for_camping" v-model="extraCopy.applies_for_camping"
                                    @click="fromFieldClicked('applies_for_camping')">
                                {{ $t('extras.bookableFor.camping') }}
                            </label>
                        </div>

                        <div class="edit-box__section bookable_for is-clearfix" v-else>
                            <label class="checkbox">
                                <span class="icon is-small" v-if="!isEditMode">
                                    <i aria-hidden="true" class="fa fa-check-circle is-valid" v-if="extraCopy.applies_for_tent"></i>
                                    <i aria-hidden="true" class="fa fa-minus-circle is-invalid" v-else></i>
                                </span>
                                <input v-if="isEditMode"
                                    class="edit-box__inline-input"
                                    type="checkbox" id="applies_for_tent"
                                    name="applies_for_tent" v-model="extraCopy.applies_for_tent"
                                    @click="fromFieldClicked('applies_for_tent')">
                                {{ $t('extras.bookableFor.tent') }}
                            </label>

                            <label class="checkbox">
                                <span class="icon is-small" v-if="!isEditMode">
                                    <i aria-hidden="true" class="fa fa-check-circle is-valid" v-if="extraCopy.applies_for_camper"></i>
                                    <i aria-hidden="true" class="fa fa-minus-circle is-invalid" v-else></i>
                                </span>
                                <input v-if="isEditMode"
                                    class="edit-box__inline-input"
                                    type="checkbox" id="applies_for_camper"
                                    name="applies_for_camper" v-model="extraCopy.applies_for_camper"
                                    @click="fromFieldClicked('applies_for_camper')">
                                {{ $t('extras.bookableFor.camper') }}
                            </label>
                            <label class="checkbox">
                                <span class="icon is-small" v-if="!isEditMode">
                                    <i aria-hidden="true" class="fa fa-check-circle is-valid" v-if="extraCopy.applies_for_caravan"></i>
                                    <i aria-hidden="true" class="fa fa-minus-circle is-invalid" v-else></i>
                                </span>
                                <input v-if="isEditMode"
                                    class="edit-box__inline-input"
                                    type="checkbox" id="applies_for_caravan"
                                    name="applies_for_caravan" v-model="extraCopy.applies_for_caravan"
                                    @click="fromFieldClicked('applies_for_caravan')">
                                {{ $t('extras.bookableFor.caravan') }}
                            </label>

                            <label class="checkbox">
                                <span class="icon is-small" v-if="!isEditMode">
                                    <i aria-hidden="true" class="fa fa-check-circle is-valid" v-if="extraCopy.applies_for_accommodation"></i>
                                    <i aria-hidden="true" class="fa fa-minus-circle is-invalid" v-else></i>
                                </span>
                                <input v-if="isEditMode"
                                    class="edit-box__inline-input"
                                    type="checkbox" id="applies_for_accommodation"
                                    name="applies_for_accommodation" v-model="extraCopy.applies_for_accommodation"
                                    @click="fromFieldClicked('applies_for_accommodation')">
                                {{ $t('extras.bookableFor.accommodation') }}
                            </label>
                        </div>
                    </div>
                </div>

                <div class="error-messages" v-if="isEditMode">
                    <span class="help is-danger" v-for="(value, key) in apiErrors">
                        <span v-for="msg in value" v-html="msg"
                              v-if="['applies_for_camper', 'applies_for_caravan', 'applies_for_accommodation', 'applies_for_camping'].indexOf(key) == -1">
                        </span>
                    </span>
                </div>

                <div class="edit-box__footer is-clearfix" v-if="isEditMode">
                    <a class="button is-link is-pulled-left" v-if="extraCopy.id" @click="deleteExtra()">
                        <span class="icon">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                        </span>
                        <span>{{ $t('extras.delete') }}</span>
                    </a>
                    <button class="button is-primary is-pulled-right"
                       :class="{ 'is-loading': isLoading, 'is-disabled': failed }">
                        {{ $t('generic.save') }}
                    </button>
                    <a class="button is-link is-pulled-right" @click="toggleEditMode()">{{ $t('generic.cancel') }}</a>
                </div>
            </div>
            <div class="edit-box__dragger" v-if="!isEditMode">
                <div class="handle">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    </form>
    </ValidationObserver>
</template>

<script>
    import VbSwitch from 'vue-bulma-switch';
    import { cloneDeep } from 'lodash';

    import filters from '../../../filters';
    import { EventBus, Tracking } from '../../../utils';
    import { Api } from '../../../api';
    import { AppModel } from '../../../models';
    import { Wysiwyg } from '../../components';
    import UseDayPrices from '../tools/UseDayPrices.vue';

    export default {
        name: 'extra',

        props: {
            value: {
                type: Object,
                'default': () => ([]),
            },
            mandatory: {
                type: Boolean,
                'default': false,
            }
        },
        filters: filters,
        components: {
            UseDayPrices,
            Wysiwyg,
            VbSwitch,
        },
        data() {
            return {
                Testfname: '',
                Testlname: '',
                Testvalue: '',
                extraCopy: {},
                isEditMode: !this.value.id,
                onlyDayPrices: AppModel.onlyDayPrices,
                isLoading: false,
                apiErrors: {},
                isDeletable: true,
                simpleCampsiteTypes: false,
            };
        },
        computed: {
            realBillingTypes() {
                if(this.mandatory) {
                    return this.billingTypes.mandatory;
                } else {
                    return this.billingTypes.normal;
                }
            },

            lang() {
                return AppModel.lang;
            },
        },
        created() {
            // copy original data to object
            this.extraCopy = Object.assign({}, cloneDeep(this.value));
            this.billingTypes = AppModel.billingTypes;
            this.extraTypes = AppModel.extraTypes;
            this.extraSubTypes = AppModel.extraSubTypes;
            this.simpleCampsiteTypes = AppModel.activeCampground.settings.simple_campsite_types;
        },
        methods: {
            submit() {
                // Only executes when validation passes!
                console.log('form submitted successfully!!!!');
            },
            saveExtra() {
                this.$refs.observer.validate().then(result => {
                    if(!this.priceAllowed()) {
                        delete this.extraCopy.price;
                        delete this.extraCopy.tax;
                    }
                    if(this.extraCopy.id) {
                        this.updateExtra();
                    } else {
                        this.addExtra();
                    }
                }).catch(result => {
                    console.log('From invalid!', result);
                    Tracking.trackEvent('Extra', 'updateExtra', 'formInvalid', null);
                });
            },

            addExtra() {
                this.onUpdateStart();
                this.extraCopy.campground_slug = AppModel.activeCampground.slug;
                Api.extras.addExtra(this.extraCopy)
                    .then((response) => {
                        if(response.ok) {
                            this.extraCopy.id = response.body.id;
                            this.extraCopy.code = response.data.code;
                            this.onUpdateDone(response.data);
                        } else {
                            this.onUpdateFailed(response);
                        }
                    }, () => {
                        this.onUpdateFailed();
                    });
                Tracking.trackEvent('Extra', 'addExtra', null, null);
            },

            updateExtra() {
                this.onUpdateStart();
                this.extraCopy.campground_slug = AppModel.activeCampground.slug;
                Api.extras.updateExtra(this.extraCopy)
                    .then((response) => {
                        if(response.ok) {
                            this.onUpdateDone();
                        } else {
                            this.onUpdateFailed(response);
                        }
                    }, () => {
                        this.onUpdateFailed();
                    });
                Tracking.trackEvent('Extra', 'updateExtra', null, null);
            },

            onUpdateStart() {
                this.isLoading = true;
            },

            onUpdateDone() {
                this.$emit('input', this.extraCopy);
                this.isLoading = false;
                this.isEditMode = false;
                this.apiErrors = {};
                EventBus.$emit(EventBus.UPDATE_CHECKS);
                EventBus.$emit(EventBus.SHOW_NOTIFICATION, { title: `<h3>${this.$t('generic.saveSuccessHeadline')}</h3>`, direction: 'Up', body: this.$t('generic.saveSuccess') });
                Tracking.trackEvent('Extra', 'updateExtra', 'success', null);
            },

            onUpdateFailed(response = null) {
                if(response) {
                    console.log('ERROR:', response.body);
                    if(typeof response.body !== 'string') {
                        this.apiErrors = response.body;
                    } else {
                        EventBus.$emit(EventBus.SHOW_NOTIFICATION, { title: `<h3>${this.$t('errors.500.title')}</h3>`, direction: 'Up', type: 'danger', body: this.$t('errors.500.content') });
                    }
                } else {
                    EventBus.$emit(EventBus.SHOW_NOTIFICATION, { title: `<h3>${this.$t('generic.formErrorHeadline')}</h3>`, direction: 'Up', type: 'danger', body: this.$t('generic.formError') });
                }
                this.isLoading = false;
                Tracking.trackEvent('Extra', 'updateExtra', 'failed', null);
            },

            deleteExtra() {
                this.$emit('del');
            },

            fromFieldClicked(fieldName) {
                Tracking.trackEvent('Extra', 'formField', fieldName, null);
            },

            toggleEditMode() {
                this.isEditMode = !this.isEditMode;
                if(!this.isEditMode) {
                    this.apiErrors = {};
                    if(!this.extraCopy.id) {
                        this.deleteExtra();
                    } else {
                        this.extraCopy = Object.assign({}, cloneDeep(this.value));
                    }
                }
                Tracking.trackEvent('Extra', 'toggleEditMode', null, null);
            },

            priceAllowed() {
                return this.billingTypes.noprice.indexOf(this.extraCopy.billing_type) === -1;
            },

            persons() {
                const transformedList = AppModel.activeCampground.persons.reduce((acc, item) => {
                    acc[item.id] = `${item.code}:  ${item.name}`;
                    return acc;
                }, {});
                return transformedList;
            },
            personTextById(id) {
                const person = AppModel.activeCampground.persons.find(item => item.id === Number(id));
                const transformedEntry = person ? `${person.code}: ${person.name}` : null;
                console.log(transformedEntry, id, this.extraCopy, AppModel.activeCampground.persons);
                return transformedEntry;
            },
            billingTypeForPersons() {
                return (this.extraCopy.billing_type || '').includes('person');
            }
        }
    };
</script>


<style lang="scss">
    @import './extra.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/extra/extra.vue